import DesktopRecordviewReducer from "../../Pages/ApplicationBlock/RecordsViewRenderer/Desktop/DesktopRecordviewReducer";

// Use named export for AppBlockReducer
export const AppBlockReducer = (blockType, device) => (draft, action) => {
  switch (blockType) {
    case "recordsview":
      switch (device) {
        case "desktop":
        case "tablet":
          return DesktopRecordviewReducer(draft, action);
        default:
          // Handle other devices or default case
          break;
      }
      break;
    default:
      // Handle other block types or default case
      break;
  }
};
